import { render, staticRenderFns } from "./ElementsCategory.vue?vue&type=template&id=3077a994&scoped=true&"
import script from "./ElementsCategory.vue?vue&type=script&lang=js&"
export * from "./ElementsCategory.vue?vue&type=script&lang=js&"
import style0 from "./ElementsCategory.vue?vue&type=style&index=0&id=3077a994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3077a994",
  null
  
)

export default component.exports